import React from 'react';
import { useIntegrationCheck } from '~Hooks';
import SKV from './Integrations/SKV';
import OrderSyncer from './OrderSyncer';

interface Props {
  orderId: string;
  isStorageOrder?: boolean;
}

const OrderSyncController: React.FunctionComponent<Props> = ({ isStorageOrder, orderId }) => {
  const hasSKVIntegration = useIntegrationCheck('SKATTEVERKET');

  if (hasSKVIntegration) {
    return <SKV orderId={orderId} isStorageOrder={isStorageOrder} />;
  }

  return <OrderSyncer orderId={orderId} isStorageOrder={isStorageOrder} />;
};

export default OrderSyncController;
